import { Event } from '@mui/icons-material'
import EventList from './EventList'
import EventEdit from './EventEdit'
import EventCreate from './EventCreate'

const eventsIndex = {
  icon: Event,
  list: EventList,
  edit: EventEdit,
  create: EventCreate,
}

export default eventsIndex
